import { render, staticRenderFns } from "./DealHealthBar.vue?vue&type=template&id=7c6044ea&scoped=true"
import script from "./DealHealthBar.vue?vue&type=script&lang=js"
export * from "./DealHealthBar.vue?vue&type=script&lang=js"
import style0 from "./DealHealthBar.vue?vue&type=style&index=0&id=7c6044ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6044ea",
  null
  
)

export default component.exports